import { IDsFilter, ID } from '../../../../../types';

export const enum UniversalFilterTagsModes {
  CONTAINS_ANY_OF = 'contains_any_of'
}

export type UniversalFilterTagsValue = IDsFilter;

export type UniversalFilterTagsFilterState = {
  mode: UniversalFilterTagsModes;
  tagIds?: ID[];
};

export type UniversalFilterTagsOnFilterStateChange = (
  state: UniversalFilterTagsFilterState
) => void;

export type UniversalFilterTagsOnChange = (
  value?: UniversalFilterTagsValue
) => void;
